var exports = {
  "kL": "DirectCallLobbyBottomSheet.module__container___dTE4TU",
  "v0": "DirectCallLobbyBottomSheet.module__buttonRow___dTE4TU",
  "Ij": "DirectCallLobbyBottomSheet.module__fullWidth___dTE4TU",
  "jf": "DirectCallLobbyBottomSheet.module__statusRow___dTE4TU",
  "Rh": "DirectCallLobbyBottomSheet.module__statusLabel___dTE4TU",
  "ht": "DirectCallLobbyBottomSheet.module__callPreview___dTE4TU",
};

module.exports = exports;
